<div class="generic-panel" [ngClass]="{'aligned-center':panelConfiguration.position === 'center'}">
    <gen-panel
            [name]="panelConfiguration.name" [position]="panelConfiguration.position">
    </gen-panel>
    <div class="navigation_btn_alignment">
        <button class="{{panelConfiguration.btnClass}} {{panelConfiguration.iconClass}}" type="button" genTooltip
                (click)="showNavigationPanel()"
                [tooltipShow]="panelConfiguration.tooltipShow"
                [tooltipText]="panelConfiguration.tooltipText"
                [tooltipPosition]="panelConfiguration.tooltipPosition"
                [tooltipYOffset]="panelConfiguration.tooltipYOffset">
        </button>
    </div>
</div>

